// extracted by mini-css-extract-plugin
export default {"slideActions":"slideActions_slideActions__92XTH"};